<template>
    <Header class="sub_menu active"></Header>

    <div class="container sub_page _news">
        <section class="sub_page_tit">
            <div class="deco_wrap">
                <i class="deco_02"><img src="img/news_left.png" /></i>
                <i class="deco_03 _xsmall spin3"><img src="img/b_icon_03.png" /></i>
                <i class="deco_04 _xxsmall blink_zoom1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_05 _xxxsmall blink_blink1"><img src="img/b_icon_04.png" /></i>
                <i class="deco_06"><img src="img/line_circle.png" /></i>
                <i class="deco_07 _small spin_blink2"><img src="img/b_icon_01.png" /></i>
                <i class="deco_08 _xsmall blink_blink3"><img src="img/b_icon_04.png" /></i>
                <i class="deco_09 _xsmall blink2"><img src="img/b_icon_02.png" /></i>
                <i class="deco_character"><img src="img/news_icon.png" /></i>
            </div>
            <div class="banner_wrap wrap_1120">
                <h2>자료집</h2>
            </div>
        </section>

        <section class="sub_page_con wrap_1120">
            <div class="total_num">
                <span>Total</span>
                <span class="total_num_value">{{ state.totalLength }}</span>
            </div>
            <div class="btn_wrap _default right_btn _board_type" v-if="state.hasAuth">
                <button type="button" class="common_btn _gray" @click="isDelete">삭제</button>
                <router-link class="common_btn w_130" to="/ArchiveWrite">글쓰기</router-link>
            </div>
            <div class="con_card sub_page_con_view">
                <ul>
                    <li class="checkbox_wrap" v-for="item in state.list" :key="item.idx" v-if="state.list.length > 0">
                        <template v-if="!state.isMobile">
                            <label :for="item.idx + ''" class="card_tag">
                                <template v-if="state.hasAuth">
                                    <input type="checkbox" name="chk" :id="item.idx + ''" :value="item.idx" v-model="state.idxList" />
                                    <em></em>
                                </template>
                            </label>

                            <router-link :to="{ name: 'ArchiveView', params: { id: item.idx } }">
                                <div class="img_wrap">
                                    <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                                    <img v-else src="img/no_img1.png" alt="" />
                                </div>
                                <div class="tit_wrap">
                                    <div class="elips_2">
                                        {{ item.title }}
                                    </div>
                                    <div class="tit_date">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</div>
                                </div>
                            </router-link>
                        </template>
                        <template v-else>
                            <label :for="item.idx + ''" class="card_tag">
                                <template v-if="state.hasAuth">
                                    <input type="checkbox" name="chk" :id="item.idx + ''" :value="item.idx" v-model="item.idx" />
                                    <em></em>
                                </template>
                            </label>

                            <router-link :to="{ name: 'ArchiveView', params: { id: item.idx } }">
                                <div class="img_wrap">
                                    <img v-if="item.thumbnail" :src="item.thumbnail" alt="" />
                                </div>
                                <div class="tit_wrap">
                                    <div class="elips_2">
                                        {{ item.title }}
                                    </div>
                                    <div class="tit_date">{{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}</div>
                                </div>
                            </router-link>
                        </template>
                    </li>
                    <li v-else class="tbody_li no_data">
                        <div class="tr_div">
                            <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                        </div>
                    </li>
                </ul>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </section>
        <ModalDefault
            v-if="modal.isShow"
            :type="modal.tab"
            :title="modal.title"
            :content="modal.content"
            @close="closeModal"
            @callback="callBackModal"
        ></ModalDefault>
    </div>

    <Footer></Footer>
</template>

<script lang="ts" config>
    import {
        Header,
        Footer,
        reactive,
        globalStore,
        onMounted,
        watch,
        newsList,
        ModalDefault,
        CommonUtils,
        userStore,
        onBeforeMount,
        types,
        apiService,
        getMessageByCode,
        PageBtn,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, NewsList: newsList, ModalDefault, PageBtn },
        setup() {
            const global = globalStore();
            const user = userStore();
            const state = reactive({
                isMobile: false as boolean,
                hasAuth: false as boolean,
                searchText: "" as string,
                idxList: [] as number[],

                list: [] as any[],
                page: 1 as number,
                size: 6 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,
            });

            const modal = reactive({
                isShow: false as boolean,
                tab: 0 as number,
                title: "" as string,
                content: "" as string,
            });

            onBeforeMount(() => {
                if (
                    user.isLogin() &&
                    (user.userInfo.gubun === 1 ||
                        (user.userInfo.isAdmin && user.roles != null && user.roles.some((item: types.RoleVO) => item.key.indexOf("news") > -1)))
                )
                    state.hasAuth = true;
            });

            onMounted(() => {
                state.isMobile = window.innerWidth < 768;
                getList();
            });

            const getList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };
                const res = await apiService.archive.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    modal.tab = -1;
                    modal.title = "예외 발생";
                    modal.content = getMessageByCode(res.returnCode);
                    modal.isShow = true;
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const closeModal = () => {
                modal.isShow = false;
                getList();
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    remove();
                } else {
                    getList();
                }
            };

            const handlePageChange = () => {};

            const isDelete = () => {
                if (state.idxList.length === 0) {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "선택된 게시글이 없습니다.";
                    modal.isShow = true;
                } else {
                    modal.tab = 5;
                    modal.title = "알림";
                    modal.content = "정말 삭제하시겠습니까?";
                    modal.isShow = true;
                }
            };

            const remove = async () => {
                if (state.idxList.length === 0) {
                    modal.tab = -1;
                    modal.title = "알림";
                    modal.content = "삭제하고자 하는 감시소식을 선택해주세요.";
                    modal.isShow = true;
                } else {
                    const param: types.ReqIdxList = {
                        idxList: state.idxList.join(","),
                    };
                    const res = await apiService.archive.removeForList(param);
                    if (res.returnCode === 0) {
                        modal.tab = -1;
                        modal.title = "알림";
                        modal.content = "삭제가 완료되었습니다.";
                        modal.isShow = true;
                        state.idxList = [];
                        getList();
                    } else if (res.returnCode === 11) {
                    } else {
                        modal.tab = -1;
                        modal.title = "예외 발생";
                        modal.content = getMessageByCode(res.returnCode);
                        modal.isShow = true;
                    }
                }
            };

            return { state, modal, CommonUtils, handlePageChange, closeModal, callBackModal, isDelete };
        },
    };
</script>
